var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kiosk-status-panel"},[_c('p',{staticClass:"kiosk-status-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"kiosk-status-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),(_vm.status !== 'no_operation')?_c('kiosk-spinner',{staticClass:"kiosk-status-spinner"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }